import { keepPreviousData } from '@tanstack/react-query';
import { useRepositoryQuery } from '@mews-commander/data-access';

export const useGlobalizationResultQuery = () =>
    useRepositoryQuery('globalization', 'get', {}, { placeholderData: keepPreviousData });
